import { updateNickname as updateNicknameEndpoint } from '../endpoints';

export async function updateNickname(nickname: string) {
  try {
    await updateNicknameEndpoint.requestAsPromise({ nickname });
    return {
      success: true,
    };
  } catch (result) {
    const { message } = (result as { error: Error }).error;

    if (!message) {
      return {
        success: false,
        error: 'Ops, algo deu errado. Tente novamente mais tarde.',
      };
    }

    return { success: false, error: message };
  }
}
